module.exports = __webpack_public_path__ + "img/logo.fd2bffb3.png";